import parse from 'html-react-parser';
import { useComponentEntry } from '@utils/component-framework';
import '@i-ark/models';
import 'react';
import '@tanstack/react-query';
import { selectItemInputEntryById } from '../../../state/selectors/entry.item-input-by-id.js';
import { iArkStore } from '../../../state/store.js';
import { inputCls } from './RichTextInput.style.js';
import { jsx } from 'react/jsx-runtime';

const RichTextInputReadonly = ({
  pageId,
  item
}) => {
  const entryKey = iArkStore.useSelector(state => state.entryKey);
  const entry = useComponentEntry(entryKey, {
    select: selectItemInputEntryById(pageId, item.id)
  });
  return /*#__PURE__*/jsx("div", {
    className: inputCls,
    children: parse(entry.data?.value ?? "")
  });
};

export { RichTextInputReadonly };
//# sourceMappingURL=RichTextInputReadonly.js.map
